import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../../services/apiService";
import { Plus } from "lucide-react";

const NewSleepFile = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState({
    sleep_content_id: "",
    duration: "",
    file_path: null,
  });

  const [audioPreview, setAudioPreview] = useState(null);
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const res = await apiService.fetchData("admin/sleep/content");
        setChannels(res.data);
      } catch (err) {
        console.error("Error fetching content:", err);
      }
    };

    fetchChannels();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file_path") {
      const file = files[0];
      setContent((prev) => ({ ...prev, file_path: file }));
      setAudioPreview(URL.createObjectURL(file));
    } else {
      setContent((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("sleep_content_id", content.sleep_content_id);
    formData.append("duration", content.duration);

    if (content.file_path) {
      formData.append("files", content.file_path);
    }

    try {
      await apiService.postData("admin/sleep/audio-file", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      navigate("/sleep/file");
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>Upload New Sleep Audio</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* Select Sleep Content */}
              <div className="form-group">
                <label>Select Content</label>
                <select
                  name="sleep_content_id"
                  value={content.sleep_content_id}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">-- Select --</option>
                  {channels.map((item) => (
                    <option
                      key={item.sleep_content_id}
                      value={item.sleep_content_id}
                    >
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>

              {/* Audio Upload */}
              <div className="form-group mt-3">
                <label>Audio File</label>
                <input
                  type="file"
                  name="file_path"
                  accept="audio/*"
                  className="form-control"
                  onChange={handleChange}
                />
                {audioPreview && (
                  <audio controls className="mt-2 w-100">
                    <source src={audioPreview} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                )}
              </div>

              {/* Duration Input */}
              <div className="form-group mt-3">
                <label>Duration (in seconds)</label>
                <input
                  type="number"
                  name="duration"
                  className="form-control"
                  value={content.duration}
                  onChange={handleChange}
                  placeholder="Enter duration"
                  min={0}
                />
              </div>

              {/* Action Buttons */}
              <div className="d-flex gap-2 mt-4">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Add Sleep
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/sleep/file")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSleepFile;
